import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useState } from "react";
import { Trash2, PenLine } from "lucide-react";
import { Link } from "react-router-dom";
import { TabsContent } from "@/components/ui/tabs";
import { DeleteConfirmDialog } from "@/components/dialog/common-dialog";
import { toast } from "react-hot-toast";
import { deleteToppingById, clearToppingMessages, fetchAllToppings } from "@/redux/slice/essential-menu-slice/toppings-slice";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { Switch } from "@/components/ui/switch";
import useAuth from "@/hooks/useAuth";
import { toggleItemStatus } from "@/api/new-api/staff-management/menu-manage/toggle-status";

function PizzaTopingsListTable({ data }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { user } = useAuth();
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const handleToggleStatus = async (itemId) => {
    try {
      const res = await toggleItemStatus("toppings", itemId);
      if (res.status === "success") {
        toast.success(res.message || "Topping status updated successfully");
        dispatch(fetchAllToppings({ restaurant_id: user?.restaurant_id, menu_id: id }));
      } else {
        toast.error(res.message || "Failed to toggle status.");
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!");
    }
  };

  const closeDeleteDialog = () => {
    setDeleteDialog(false);
  };
  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("ID is required to delete.");
        return;
      }
      dispatch(clearToppingMessages());
      const res = await dispatch(deleteToppingById(id));
      if (deleteToppingById.fulfilled.match(res)) {
        toast.success("Tropping deleted successfully.");
        setDeleteDialog(false);
        dispatch(clearToppingMessages());
      } else if (deleteToppingById.rejected.match(res)) {
        toast.error(res?.payload);
      }
    } catch (error) {
      toast.error(error.message || "Something went wrong!.");
    } finally {
      closeDeleteDialog();
    }
  };
  return (
    <TabsContent className="mt-5" value="drink-list-category">
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead>Name</TableHead>
            <TableHead>Description</TableHead>
            <TableHead>Price</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{item?.name}</TableCell>
                <TableCell>{item?.description}</TableCell>
                <TableCell>${item?.price}</TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    {item?.status === "active" ? (
                      <>
                        <span className="text-cgreen text-base">Active</span>
                        <Switch
                          checked={true}
                          onCheckedChange={() => handleToggleStatus(item.id)}
                        />
                      </>
                    ) : item?.status === "inactive" ? (
                      <>
                        <span className="text-cred text-base">Inactive</span>
                        <Switch
                          checked={false}
                          onCheckedChange={() => handleToggleStatus(item.id)}
                        />
                      </>
                    ) : item?.status === "draft" ? (
                      <span className="text-cred text-base">Draft</span>
                    ) : (
                      <span className="text-cred text-base">Archived</span>
                    )}
                  </div>
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-8">
                    <Link
                      to={`/backoffice/menu/essentail-menu/${id}/${item.id}/update-tropping`}
                      className="cursor-pointer"
                    >
                      <PenLine className="text-cyellow" size={18} />
                    </Link>

                    {item?.status !== "archive" && item?.status !== "archived" && (
                      <Trash2
                        onClick={() => {
                          setDeleteDialog(true);
                          setSelectedId(item?.id);
                        }}
                        className="text-cred cursor-pointer"
                        size={18}
                      />
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={5} className="text-center">
                No data found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      {/* dialog */}
      <DeleteConfirmDialog
        onConfirm={() => {
          deleteHandler(selectedId);
        }}
        isOpen={deleteDialog}
        onClose={closeDeleteDialog}
      />
    </TabsContent>
  );
}

export default PizzaTopingsListTable;
